import script from "./DecUseEn.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecUseEn.vue?vue&type=script&setup=true&lang=ts"

import "./DecUseEn.vue?vue&type=style&index=0&id=686639ec&lang=scss"

const __exports__ = script;

export default __exports__